import { Directive, HostListener, ElementRef, Input, inject } from '@angular/core';

@Directive({ selector: '[hover-class]' })
export class HoverClassDirective {
    elementRef = inject(ElementRef);

    @Input('hover-class') hoverClass: string;

    @HostListener('mouseenter') onMouseEnter() {
        this.elementRef.nativeElement.classList.add(this.hoverClass);
    }

    @HostListener('mouseleave') onMouseLeave() {
        this.elementRef.nativeElement.classList.remove(this.hoverClass);
    }

}
